(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lovable-featured-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var buttons = document.querySelectorAll('[data-add-to-cart]');
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.disabled) return;

        var variantId = btn.dataset.variantId;
        var quantity = parseInt(btn.dataset.quantity, 10) || 1;
        var originalText = btn.textContent.trim();

        btn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: variantId, quantity: quantity })
        })
        .then(function(r) {
          if (!r.ok) throw new Error('Add to cart failed');
          return r.json();
        })
        .then(function() {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          btn.textContent = 'Added!';
          setTimeout(function() { btn.textContent = originalText; }, 1500);
        })
        .catch(function(err) {
          console.error(err);
          btn.textContent = 'Error';
          setTimeout(function() { btn.textContent = originalText; }, 1500);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lovable-header"]) return;
  try {
    
  var s_btn = document.getElementById('lh__search-link');
  var s_btn_c = document.getElementById('lh-search__close');
    s_btn.addEventListener('click', function () {    
      document.getElementById('lh__col-search').classList.add('open');
    });
    s_btn_c.addEventListener('click', function () {    
      document.getElementById('lh__col-search').classList.remove('open');
    });
(function() {
  'use strict';

  var header      = document.getElementById('lovable-header');
  if (!header) return;

  var hamburger   = header.querySelector('[data-lh-hamburger]');
  var mobileMenu  = document.getElementById('lh-mobile-menu');

  /* — hamburger — */
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      var open = mobileMenu.hidden;
      mobileMenu.hidden = !open;
      hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');

      /* swap menu / X icon */
      var svg = hamburger.querySelector('svg');
      if (svg) {
        svg.innerHTML = open
          ? '<line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>'
          : '<line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/>';
      }
    });
  }

  /* — mobile submenus — */
  var subToggles = header.querySelectorAll('[data-lh-mobile-sub]');
  subToggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panelId = btn.getAttribute('aria-controls');
      var panel   = panelId ? document.getElementById(panelId) : btn.nextElementSibling;
      var chevron = btn.querySelector('.lh__mobile-chevron');
      var isOpen  = btn.getAttribute('aria-expanded') === 'true';

      if (panel) panel.hidden = isOpen;
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (chevron) chevron.classList.toggle('is-open', !isOpen);
    });
  });

  /* — update spacer height dynamically — */
  function updateSpacer() {
    var spacer = document.querySelector('.lh__spacer');
    if (spacer) spacer.style.height = header.offsetHeight + 'px';
  }
  updateSpacer();
  window.addEventListener('resize', updateSpacer);

  /* — align dropdowns to right when near right edge — */
  function alignDropdowns() {
    var navItems = document.querySelectorAll('.lh__nav-item');
    var viewportWidth = window.innerWidth;
    var threshold = 450; // pixels from right edge to trigger right alignment

    navItems.forEach(function (item) {
      var rect = item.getBoundingClientRect();
      var distanceFromRight = viewportWidth - rect.right;
      var dropdown = item.querySelector('.lh__dropdown');

      if (dropdown) {
        // Temporarily show dropdown to measure its width
        var wasHidden = dropdown.style.display === 'none' || getComputedStyle(dropdown).display === 'none';
        if (wasHidden) {
          dropdown.style.display = 'block';
          dropdown.style.visibility = 'hidden';
        }
        
        var dropdownPanel = dropdown.querySelector('.lh__dropdown-panel');
        if (dropdownPanel) {
          var dropdownWidth = dropdownPanel.offsetWidth;
          var wouldOverflow = (rect.left + dropdownWidth) > viewportWidth;
          
          if (distanceFromRight < threshold || wouldOverflow) {
            item.classList.add('lh__nav-item--right');
          } else {
            item.classList.remove('lh__nav-item--right');
          }
        }
        
        // Hide again
        if (wasHidden) {
          dropdown.style.display = '';
          dropdown.style.visibility = '';
        }
      }
    });
  }
  alignDropdowns();
  window.addEventListener('resize', alignDropdowns);

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lovable-more-from-brand"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (window.__lovableBrandAtcListener) return;
    window.__lovableBrandAtcListener = true;

    document.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-add-to-cart]');
      if (!btn || btn.disabled) return;

      e.preventDefault();
      e.stopPropagation();

      const variantId = btn.dataset.variantId;
      const quantity = parseInt(btn.dataset.quantity, 10) || 1;
      const originalText = btn.textContent.trim();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
      .then(r => {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        btn.textContent = 'Added!';
        setTimeout(() => { btn.textContent = originalText; }, 1500);
      })
      .catch(err => {
        console.error(err);
        btn.textContent = 'Error';
        setTimeout(() => { btn.textContent = originalText; }, 1500);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lovable-product-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const hero = document.querySelector('[data-lph-hero]');
    if (!hero) return;

    const form = document.getElementById('lph-product-form');
    const variantInput = document.getElementById('lph-variant-id');
    const quantityInput = document.getElementById('lph-quantity-input');
    const qtyDisplay = document.getElementById('lph-qty-display');
    const mainImage = document.getElementById('lph-main-image');
    const thumbs = hero.querySelectorAll('.lph__thumb');
    const addBtn = document.getElementById('lph-add-to-cart');
    const priceEl = document.getElementById('lph-price');
    const compareEl = document.getElementById('lph-compare');
    const saveEl = document.getElementById('lph-save');

    // Parse variants from Shopify's global product object if available
    let productData = null;
    if (window.Shopify && window.Shopify.theme && window.Shopify.theme.handle) {
      // product object is typically injected by Shopify as window.product or window.ShopifyAnalytics
    }

    // Build variant map from data attributes rendered by Liquid is not trivial here.
    // We rely on the form submission to Shopify's standard handler for add-to-cart.
    // For variant switching, we read the product JSON via a fetch to the current URL + .js
    const productHandle = hero.closest('[data-section-id]')?.dataset?.sectionId || '';
    const productUrl = window.location.pathname;

    function fetchProductJson() {
      return fetch(productUrl + '.js')
        .then(r => r.json())
        .catch(() => null);
    }

    // Variant switching: simple single-option support via URL parameter matching
    const variantButtons = hero.querySelectorAll('[data-option-value]');
    if (variantButtons.length > 0) {
      variantButtons.forEach(btn => {
        btn.addEventListener('click', function() {
          const group = this.closest('.lph__variant-group');
          const optionIndex = parseInt(group.dataset.optionIndex, 10);
          const value = this.dataset.optionValue;

          // Update active state
          group.querySelectorAll('[data-option-value]').forEach(b => b.classList.remove('is-active'));
          this.classList.add('is-active');

          // Update selected label
          const label = group.querySelector('[data-selected-label]');
          if (label) label.textContent = 'Selected: ' + value;

          // Build option selections
          const selections = {};
          hero.querySelectorAll('.lph__variant-group').forEach(g => {
            const active = g.querySelector('[data-option-value].is-active');
            if (active) {
              selections[g.dataset.optionIndex] = active.dataset.optionValue;
            }
          });

          // Fetch product JSON and find matching variant
          fetchProductJson().then(product => {
            if (!product) return;
            const matched = product.variants.find(v => {
              return Object.keys(selections).every(idx => {
                const idxNum = parseInt(idx, 10) - 1;
                return v.options[idxNum] === selections[idx];
              });
            });
            if (matched) {
              variantInput.value = matched.id;
              updatePrice(matched);
              updateUrl(matched.id);
              updateAvailability(matched);
              updateVariantImage(matched, product);
              document.dispatchEvent(new CustomEvent('lovable:variantchange', { detail: { variant: matched } }));
            }
          });
        });
      });
    }

    function updatePrice(variant) {
      if (!priceEl) return;
      priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = 'block';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (saveEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          saveEl.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price);
          saveEl.style.display = 'block';
        } else {
          saveEl.style.display = 'none';
        }
      }
    }

    function formatMoney(cents) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
    }

    function updateUrl(variantId) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }

    function updateAvailability(variant) {
      if (!addBtn) return;
      if (variant.available) {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Cart';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = 'Out of Stock';
      }
    }

    function updateVariantImage(variant, product) {
      if (!mainImage || !product || !variant) return;

      let targetThumb = null;

      // Strategy 1: Match by variant image_id
      if (variant.image_id) {
        const variantMedia = product.media.find(m => m.id === variant.image_id);
        if (variantMedia) {
          const mediaIndex = product.media.indexOf(variantMedia);
          targetThumb = hero.querySelector(`[data-media-index="${mediaIndex}"]`);
        }
      }

      // Strategy 2: Match by variant index to thumbnail index
      if (!targetThumb) {
        const variantIndex = product.variants.findIndex(v => v.id === variant.id);
        if (variantIndex >= 0 && thumbs[variantIndex]) {
          targetThumb = thumbs[variantIndex];
        }
      }

      // Strategy 3: Match by alt text containing variant options
      if (!targetThumb) {
        thumbs.forEach(thumb => {
          const mediaIndex = parseInt(thumb.dataset.mediaIndex, 10);
          if (product.media && product.media[mediaIndex]) {
            const media = product.media[mediaIndex];
            const mediaAlt = (media.alt || '').toLowerCase();

            const hasMatch = variant.options.some(option => {
              const optionLower = option.toLowerCase().trim();
              return mediaAlt.includes(optionLower) || mediaAlt === optionLower;
            });

            if (hasMatch) {
              targetThumb = thumb;
            }
          }
        });
      }

      // If we found a matching thumbnail, update the main image
      if (targetThumb) {
        const newSrc = targetThumb.dataset.mediaSrc;
        const newSrcset = targetThumb.dataset.mediaSrcset;

        if (newSrc) {
          mainImage.src = newSrc;
          if (newSrcset) {
            mainImage.srcset = newSrcset;
          }

          // Update thumbnail active state
          thumbs.forEach(t => t.classList.remove('is-active'));
          targetThumb.classList.add('is-active');
        }
      }
    }

    // Quantity
    hero.querySelectorAll('[data-qty]').forEach(btn => {
      btn.addEventListener('click', function() {
        let qty = parseInt(qtyDisplay.textContent, 10) || 1;
        if (this.dataset.qty === 'decrease') {
          qty = Math.max(1, qty - 1);
        } else {
          qty += 1;
        }
        qtyDisplay.textContent = qty;
        quantityInput.value = qty;

        // Sync sticky bar
        const stickyQty = document.querySelector('[data-lsbb-qty]');
        if (stickyQty) stickyQty.textContent = qty;
      });
    });

    // Thumbnail switching
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', function() {
        const newSrc = this.dataset.mediaSrc;
        const newSrcset = this.dataset.mediaSrcset;
        if (newSrc && mainImage) {
          mainImage.src = newSrc;
          mainImage.srcset = newSrcset;
        }
        thumbs.forEach(t => t.classList.remove('is-active'));
        this.classList.add('is-active');
      });
    });

    // Engraving & Gift option accordions
    hero.querySelectorAll('.lph__option-header').forEach(header => {
      header.addEventListener('click', function() {
        const option = this.dataset.option;
        const content = document.getElementById('lph-' + option + '-content');
        const isOpen = this.classList.contains('is-open');
        this.classList.toggle('is-open');
        if (content) content.classList.toggle('is-open');
        this.setAttribute('aria-expanded', !isOpen);
      });
    });

    const engravingCheckbox = document.getElementById('lph-engraving-enabled');
    const engravingText = document.getElementById('lph-engraving-text');
    const engravingNotes = document.getElementById('lph-engraving-notes');
    if (engravingCheckbox) {
      engravingCheckbox.addEventListener('change', function() {
        if (engravingText) engravingText.disabled = !this.checked;
        if (engravingNotes) engravingNotes.disabled = !this.checked;
      });
    }

    const giftCheckbox = document.getElementById('lph-gift-enabled');
    const giftMessage = document.getElementById('lph-gift-message');
    const giftPackaging = document.getElementById('lph-gift-packaging');
    if (giftCheckbox) {
      giftCheckbox.addEventListener('change', function() {
        if (giftMessage) giftMessage.disabled = !this.checked;
        if (giftPackaging) giftPackaging.disabled = !this.checked;
      });
    }

    // AJAX add to cart
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        if (addBtn.disabled) return;

        const formData = new FormData(form);

        // Collect line item properties (engraving / gift) for the parent variant
        const properties = {};
        formData.forEach((value, key) => {
          const match = key.match(/^properties\[(.+)]$/);
          if (match && value) properties[match[1]] = value;
        });

        const quantity = parseInt(formData.get('quantity'), 10) || 1;
        const parentId = variantInput ? variantInput.value : null;

       const items = [];

        // Standard Shopify PDP variant
        if (parentId) {
          items.push({
            id: parentId,
            quantity: quantity
          });
        }

        // GiftShip / additional variants
        formData.getAll('id[]').forEach(id => {
          items.push({
            id,
            quantity: 1
          });
        });

        // Attach properties to the parent line item
        if (parentId) {
          const parentItem = items.find(item => item.id === parentId);
          if (parentItem && Object.keys(properties).length) parentItem.properties = properties;
        }

        const payload = { items: items };

        addBtn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(payload)
        })
          .then(r => {
            if (!r.ok) return r.json().then(err => { throw err; });
            return r.json();
          })
          .then(item => {
            addBtn.textContent = 'Added!';
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: null }, bubbles: true }));
            if (window.CartDrawer && window.CartDrawer.refresh) window.CartDrawer.refresh();
            setTimeout(() => {
              addBtn.textContent = 'Add to Cart';
              if (window.CartDrawer && window.CartDrawer.open) window.CartDrawer.open();
            }, 150);
          })
          .catch(err => {
            console.error('Add to cart failed', err);
            addBtn.textContent = 'Add to Cart';
            const message = err && err.description ? err.description : 'Unable to add item to cart.';
            alert(message);
          });
      });
    }
  })();

  document.addEventListener("click", function(e) {
  if (e.target.closest(".engraving-checkbox")) {
    document.querySelectorAll(".Engraved-Text").forEach(function(el) {
      el.classList.toggle("show-text");
    });
  }
});

  document.addEventListener("click", function(e) {
  if (e.target.closest(".gift-checkbox")) {
    document.querySelectorAll(".Gift-Text").forEach(function(el) {
      el.classList.toggle("show-text");
    });
  }
});
  (function() {
    let observer;
    function createGsAppToggle() {
      const gsApp = document.getElementById('gsAppContainer');
      if (!gsApp || gsApp.dataset.toggleSetup) return;
      const prev = gsApp.previousElementSibling;
      if (prev && prev.classList.contains('lph__addons-toggle')) {
        gsApp.dataset.toggleSetup = 'true';
        return;
      }
      gsApp.dataset.toggleSetup = 'true';
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'lph__option-header lph__addons-toggle';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-controls', 'gsAppContainer');
      toggle.innerHTML = `
        <span class="lph__option-label">
          <svg class="lph__option-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M8 21h8"/><path d="M4 16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2"/></svg>
          Add Gift & Personalization Options
          <span class="lph__option-badge">Optional</span>
        </span>
        <svg class="lph__chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
      `;
      gsApp.parentNode.insertBefore(toggle, gsApp);
      toggle.addEventListener('click', function() {
        const isOpen = gsApp.classList.contains('is-open');
        if (isOpen) {
          gsApp.classList.remove('is-open');
          toggle.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          gsApp.classList.add('is-open');
          toggle.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
      if (observer) observer.disconnect();
    }
    observer = new MutationObserver(createGsAppToggle);
    observer.observe(document.body, { childList: true, subtree: true });
    createGsAppToggle();
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lovable-product-info"]) return;
  try {
    
  (function() {
    // Option accordions
    const optionHeaders = document.querySelectorAll('.lpi__option-header');
    
    optionHeaders.forEach(header => {
      header.addEventListener('click', function() {
        const option = this.dataset.option;
        const content = document.getElementById('lpi-' + option + '-content');
        const isOpen = this.classList.contains('is-open');
        
        // Toggle current
        this.classList.toggle('is-open');
        content.classList.toggle('is-open');
        this.setAttribute('aria-expanded', !isOpen);
      });
    });

    // Engraving checkbox enables/disables inputs
    const engravingCheckbox = document.getElementById('lpi-engraving-enabled');
    const engravingText = document.getElementById('lpi-engraving-text');
    const engravingNotes = document.getElementById('lpi-engraving-notes');
    
    if (engravingCheckbox) {
      engravingCheckbox.addEventListener('change', function() {
        engravingText.disabled = !this.checked;
        engravingNotes.disabled = !this.checked;
      });
    }

    // Gift checkbox enables/disables inputs
    const giftCheckbox = document.getElementById('lpi-gift-enabled');
    const giftMessage = document.getElementById('lpi-gift-message');
    const giftPackaging = document.getElementById('lpi-gift-packaging');
    
    if (giftCheckbox) {
      giftCheckbox.addEventListener('change', function() {
        giftMessage.disabled = !this.checked;
        giftPackaging.disabled = !this.checked;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lovable-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (window.__lovableAtcListener) return;
    window.__lovableAtcListener = true;

    document.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-add-to-cart]');
      if (!btn || btn.disabled) return;

      e.preventDefault();
      e.stopPropagation();

      const variantId = btn.dataset.variantId;
      const quantity = parseInt(btn.dataset.quantity, 10) || 1;
      const originalText = btn.textContent.trim();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
      .then(r => {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        btn.textContent = 'Added!';
        setTimeout(() => { btn.textContent = originalText; }, 1500);
      })
      .catch(err => {
        console.error(err);
        btn.textContent = 'Error';
        setTimeout(() => { btn.textContent = originalText; }, 1500);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lovable-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const containers = document.querySelectorAll('.lpdt__container');

    containers.forEach(container => {
      const tabs = container.querySelectorAll('.lpdt__tab');
      const panels = container.querySelectorAll('.lpdt__panel');

      tabs.forEach(tab => {
        tab.addEventListener('click', function() {
          const targetId = this.getAttribute('aria-controls');

          tabs.forEach(t => {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });

          panels.forEach(p => {
            p.classList.remove('is-active');
          });

          this.classList.add('is-active');
          this.setAttribute('aria-selected', 'true');

          const targetPanel = container.querySelector('#' + targetId);
          if (targetPanel) {
            targetPanel.classList.add('is-active');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lovable-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (window.__lovableAtcListener) return;
    window.__lovableAtcListener = true;

    document.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-add-to-cart]');
      if (!btn || btn.disabled) return;

      e.preventDefault();
      e.stopPropagation();

      const variantId = btn.dataset.variantId;
      const quantity = parseInt(btn.dataset.quantity, 10) || 1;
      const originalText = btn.textContent.trim();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
      .then(r => {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        btn.textContent = 'Added!';
        setTimeout(() => { btn.textContent = originalText; }, 1500);
      })
      .catch(err => {
        console.error(err);
        btn.textContent = 'Error';
        setTimeout(() => { btn.textContent = originalText; }, 1500);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lovable-similar-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (window.__lovableAtcListener) return;
    window.__lovableAtcListener = true;

    document.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-add-to-cart]');
      if (!btn || btn.disabled) return;

      e.preventDefault();
      e.stopPropagation();

      const variantId = btn.dataset.variantId;
      const quantity = parseInt(btn.dataset.quantity, 10) || 1;
      const originalText = btn.textContent.trim();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
      .then(r => {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        btn.textContent = 'Added!';
        setTimeout(() => { btn.textContent = originalText; }, 1500);
      })
      .catch(err => {
        console.error(err);
        btn.textContent = 'Error';
        setTimeout(() => { btn.textContent = originalText; }, 1500);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lovable-sticky-buy-bar"]) return;
  try {
    
  (function() {
    const stickyBar = document.getElementById('lovable-sticky-buy-bar');
    if (!stickyBar) return;

    const mainForm = document.getElementById('lph-product-form');
    const mainQtyInput = document.getElementById('lph-quantity-input');
    const mainQtyDisplay = document.getElementById('lph-qty-display');
    const stickyQtyValue = stickyBar.querySelector('[data-lsbb-qty]');
    const stickyAddBtn = stickyBar.querySelector('[data-lsbb-add]');
    const stickyPrice = stickyBar.querySelector('[data-lsbb-price]');

    function formatMoney(cents) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
    }

    // Sync price/availability when hero variant changes
    document.addEventListener('lovable:variantchange', function(e) {
      const variant = e.detail && e.detail.variant;
      if (!variant) return;
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (stickyAddBtn) {
        stickyAddBtn.disabled = !variant.available;
        stickyAddBtn.textContent = variant.available ? 'Add to Cart' : 'Out of Stock';
      }
    });

    // Show/hide on scroll
    const scrollThreshold = 600;
    function onScroll() {
      if (window.scrollY > scrollThreshold) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    }
    window.addEventListener('scroll', onScroll);
    onScroll();

    function setQuantity(qty) {
      qty = Math.max(1, qty);
      stickyQtyValue.textContent = qty;
      if (mainQtyInput) mainQtyInput.value = qty;
      if (mainQtyDisplay) mainQtyDisplay.textContent = qty;
    }

    // Sticky quantity buttons
    stickyBar.querySelectorAll('[data-lsbb-qty-action]').forEach(btn => {
      btn.addEventListener('click', function() {
        let qty = parseInt(stickyQtyValue.textContent, 10) || 1;
        if (this.dataset.lsbbQtyAction === 'decrease') {
          qty = Math.max(1, qty - 1);
        } else {
          qty += 1;
        }
        setQuantity(qty);
      });
    });

    // Sticky add to cart triggers the main hero submit button
    if (stickyAddBtn && mainForm) {
      stickyAddBtn.addEventListener('click', function() {
        if (this.disabled) return;
        const mainSubmit = mainForm.querySelector('button[type="submit"]');
        if (mainSubmit) mainSubmit.click();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    const headerEl = document.querySelector('header-section[data-cart-type]');
    const cartType = headerEl ? headerEl.getAttribute('data-cart-type') : undefined;
    if (cartType !== 'page') {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', async (event) => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-ajax`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const sections = await response.json();
      const state = { sections };

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            product: state,
          },
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: state,
          },
        })
      );
    } catch (e) {
      console.warn('Failed to load cart sections after add:', e);
    }
  });

  document.addEventListener('product-form:message:success', (event) => event.preventDefault());

  } catch(e) { console.error(e); }
})();
})();
